/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export function isRefObject(value) {
    return value != null && typeof value.current !== "undefined";
}
export function isRefCallback(value) {
    return typeof value === "function";
}
export function combineRefs(ref1, ref2) {
    return function (el) {
        ref1(el);
        ref2(el);
    };
}
export function getRef(ref) {
    var _a;
    if (ref === null) {
        return null;
    }
    return (_a = ref.current) !== null && _a !== void 0 ? _a : ref;
}
/**
 * Assign the given ref to a target, either a React ref object or a callback which takes the ref as its first argument.
 */
export function setRef(refTarget, ref) {
    if (refTarget === undefined) {
        return;
    }
    if (isRefObject(refTarget)) {
        refTarget.current = ref;
    }
    else if (isRefCallback(refTarget)) {
        refTarget(ref);
    }
}
export function refHandler(refTargetParent, refTargetKey, refProp) {
    if (isRefObject(refProp)) {
        refTargetParent[refTargetKey] = refProp;
        return refProp;
    }
    return function (ref) {
        refTargetParent[refTargetKey] = ref;
        if (isRefCallback(refProp)) {
            refProp(ref);
        }
    };
}
//# sourceMappingURL=refs.js.map